/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CheckinRequestBuilderRequestsMetadata, type CheckinRequestBuilder } from './checkin/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/salesreps/devices
 */
export interface DevicesRequestBuilder extends BaseRequestBuilder<DevicesRequestBuilder> {
    /**
     * The checkin property
     */
    get checkin(): CheckinRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const DevicesRequestBuilderUriTemplate = "{+baseurl}/api/salesreps/devices";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const DevicesRequestBuilderNavigationMetadata: Record<Exclude<keyof DevicesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    checkin: {
        requestsMetadata: CheckinRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
